const authLangs = {
  login: "Login",
  loginSystem: "Login to system",
  newUser: "New user?",
  contactAdmin: "Contact Admin",
};
export default authLangs;
